// extracted by mini-css-extract-plugin
export default {"container":"yV","productarea":"zV","btn":"AV","promowrapper":"BV","upsellarea":"CV","subtitle":"EV","system":"FV","desc":"GV","cardswrap":"HV","cards":"IV","squareloadingcontainer":"JV","squareloading33":"KV"};
    if(module.hot) {
      // 1738064243150
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  